export default __webpack_public_path__ + "static/media/polaroid5.e193599a.svg";